export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      UserIdentity: 'member001',
      ClientFlg: true,
      MentorFlg: false,
      ProMentorFlg: false,
      ClientInfo: {
        UserName: 'クライアント太郎',
        Sex: 1,
        Birthday: '1980/10/22',
        RegistDt: '2020/10/03 17:20:36',
        Profile: 'プロフィールテキスト',
        PointBalance: 2300
      },
      AdminMemo: 'xxxxxxxxxxx'
    }
  }
}